module.exports = __webpack_public_path__ + "static/assets/bd58c18e2c4af10dfc628dbc980864e5.png";